import { useEffect } from "react";

import { Box, Divider, Stack } from "@mui/material";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import PageTitle from "components/elements/PageTitle";
import Panel from "components/elements/Panel";
import Switch from "components/elements/Switch";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { getLocalStorageBooleanValue } from "utils";

import PushSwitch from "./PushSwitch";

const NotificationsPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isNotificationsEnabled = getLocalStorageBooleanValue("featureNotificationsEnabled", false);

  useEffect(() => {
    if (!isNotificationsEnabled) {
      navigate("/nastaveni");
    }
  }, [isNotificationsEnabled]);

  return (
    <Grid container justifyContent="center" spacing={8}>
      <PageTitle i18nKey="notifications.meta_title" />
      <Grid item sx={{ width: "100%", maxWidth: "sm" }}>
        <Panel sx={{ p: 4, mb: 10 }}>
          <Typography variant="h5" component="h1" fontWeight={600} sx={{ pb: 3, color: "tertiary.main" }}>
            {t("notifications.title")}
          </Typography>
          <Stack spacing={2} divider={<Divider />}>
            <Box>
              <Typography variant="h6" component="h2" fontWeight={600} sx={{ pb: 1, color: "secondary.main" }}>
                {t("notifications.email.heading")}
              </Typography>
              <Grid container justifyContent="center" sx={{ pb: 2 }}>
                <Grid item sx={{ py: 2, pr: 2, alignSelf: "center" }} xs={12} md={8}>
                  <Typography variant="body1">{t("notifications.email.orderErrors.title")}</Typography>
                  <Typography variant="body2" color={"text.secondary"}>
                    {t("notifications.email.orderErrors.description")}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={4} sx={{ alignSelf: "center", textAlign: "right" }}>
                  <Switch disabled />
                </Grid>
              </Grid>
            </Box>
            <Box>
              <Typography variant="h6" component="h2" fontWeight={600} sx={{ pb: 1, color: "secondary.main" }}>
                {t("notifications.push.heading")}
              </Typography>
              <Grid container justifyContent="center" sx={{ pb: 2 }}>
                <Grid item sx={{ py: 2, pr: 2, alignSelf: "center" }} xs={12} md={8}>
                  <Typography variant="body1">{t("notifications.push.title")}</Typography>
                  <Typography variant="body2" color={"text.secondary"}>
                    {t("notifications.push.description")}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={4} sx={{ alignSelf: "center", textAlign: "right" }}>
                  <PushSwitch />
                </Grid>
              </Grid>
            </Box>
          </Stack>
        </Panel>
      </Grid>
    </Grid>
  );
};
export default NotificationsPage;
